import { Button, Container, Dialog, DialogActions, DialogTitle, Paper } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AxiosError } from 'axios';
import clsx from 'clsx';
import { getSelectedSupplier } from 'features/settings/settingsSlice';
import CartActions from 'features/shoppingCart/CartActions';
import CartSelection from 'features/shoppingCart/CartSelection';
import {
  getCurrentCart,
  getShoppingCartState,
  SupplierItem,
  toggleSelectedItem,
} from 'features/shoppingCart/shoppingCartSlice';
import { useThunkDispatch } from 'hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import SupplierSelection from '../settings/SupplierSelection';
import CartControls from './CartControls';
import CartMembers from './CartMembers';
import NewCartButton from './NewCartButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0),
    },
    controls: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-around',
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
    },
  }),
);

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'cart']);
  const shoppingCart = useSelector(getShoppingCartState);
  const currentCart = useSelector(getCurrentCart);
  const selectedSupplier = useSelector(getSelectedSupplier);
  const dispatch = useThunkDispatch();

  const toggleSelection = (cartId: number) => (cartMember: number) => (item: SupplierItem) => {
    dispatch(toggleSelectedItem({ cartId, cartMember, item }));
  };

  const [error, setError] = useState<string | null>(null);

  const handleAvailabilityError = (error: AxiosError) => {
    console.error({ error });
    if (!!error.response) {
      setError(error.message);
    } else {
      setError(t('no_server'));
    }
  };

  const handleClose = () => {
    setError(null);
  };

  return (
    <Container maxWidth="xl">
      <Dialog
        open={!!error}
        onClose={handleClose}
        aria-labelledby="availability-error-dialog-title"
      >
        <DialogTitle id="availability-error-dialog-title">{t('cart:availability_err')}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('cart:confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      <Paper className={clsx(classes.paper, classes.controls)}>
        <NewCartButton iconProps={{ className: classes.rightIcon }} />
        <CartSelection />
        <CartControls
          cartId={currentCart.cartId}
          numCarts={shoppingCart.carts.length}
          cartMembers={currentCart.items}
          handleAvailabilityError={handleAvailabilityError}
        />
        <SupplierSelection />
      </Paper>

      <Paper className={classes.paper}>
        <CartMembers
          selectedSupplier={selectedSupplier?.name}
          toggleSelectedCartMember={toggleSelection(currentCart.cartId)}
          cart={currentCart}
          handleAvailabilityError={handleAvailabilityError}
        />
      </Paper>
      {!!currentCart.items.length && (
        <Paper className={classes.paper}>
          <CartActions />
        </Paper>
      )}
    </Container>
  );
};
